import * as actions from './actions.js'

const defaultModulesState = {
  crudAction: '',
  subpage: '',
  moduleId: '',
  sequenceId: ''
}

const modulesRoutingReducer = (state = defaultModulesState, action) => {
  switch(action.type) {
    case actions.SET_RESOURCE_ACTION:
      return Object.assign({}, state, { crudAction: action.crudAction })
    case actions.SET_SUBPAGE:
      return Object.assign({}, state, { subpage: action.subpage, sequenceId: '' })
    case actions.SET_MODULE_ID:
      return Object.assign({}, state, { moduleId: action.moduleId })
    case actions.SET_SEQUENCE_ID:
      return Object.assign({}, state, { sequenceId: action.sequenceId })
    default:
      return state
  }
}

export default modulesRoutingReducer;
